import { CrudService } from 'ui-shared';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { EmpresaGestorCatalogoEntity } from "@catalogo/models/operacional/empresa-gestor-catalogo.entity";
import { OPERACAO_API_URL } from "@catalogo/features/compartilhado/const/constantes";

@Injectable({ providedIn: 'root' })
export class EmpresaGestorCatalogoDataService extends CrudService<EmpresaGestorCatalogoEntity> {

    protected url: string;
    urlOriginal: string;

    constructor(
        @Inject(OPERACAO_API_URL) urlBase: string,
        @Inject(HttpClient) protected httpClient: HttpClient
    ) {
        super(urlBase, httpClient);
        this.urlOriginal = `${urlBase}/v1/Empresa/<id>/GestorCatalogo`;
    }

    public withParentId(parentId: string) {
        this.url = this.urlOriginal.replace("<id>", parentId);
        return this;
    }
}
